import { render, staticRenderFns } from "./ebs-payment.vue?vue&type=template&id=6aba75d9&"
import script from "./ebs-payment.vue?vue&type=script&lang=js&"
export * from "./ebs-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports